 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"425165828cbca8c3464f0263eb269c76bc54a018","1":"framework","2":"styles","3":"94cf43ee5387c53f6634a485d1b467e7cce5efbe","4":"14a55478639e0cdf3cd4295950bf8d289493dc1d","5":"fb62585424584bf0aebd50b6c31649333436e699","6":"2fbf9dd2","7":"8b80437e12f5ecd78ade0da750decdae4c4ad33a","8":"16811c1f5bbd073a562b37b9515672090c81201a","9":"fd2cc789a711de3bc39f0d7b21319bf255ccaa06","10":"213ea3da8bbff2fd5791aba3ac8b2bdf5e2890c2","11":"94726e6d","12":"94ff9f3230cde4617b6e678422f49ec13db4bed2","13":"cdf3896354c49e2801630ab4cf184284fdbe0d65","14":"component---src-pages-oftwomindsmx-js","17":"component---cache-caches-gatsby-plugin-offline-app-shell-js","18":"component---src-pages-404-js","19":"component---src-pages-about-js","20":"component---src-pages-contact-careers-js","21":"component---src-pages-contact-client-inquiries-js","22":"component---src-pages-contact-index-js","23":"component---src-pages-contact-mentorship-program-js","24":"component---src-pages-index-js","25":"component---src-pages-philosophy-js","26":"component---src-pages-preview-js","27":"component---src-pages-privacy-policy-js","28":"component---src-pages-roanne-js","29":"component---src-pages-work-js","30":"component---src-templates-category-js","31":"component---src-templates-project-js","33":"reactPlayerDailyMotion","34":"reactPlayerFacebook","35":"reactPlayerFilePlayer","36":"reactPlayerKaltura","37":"reactPlayerMixcloud","38":"reactPlayerPreview","39":"reactPlayerSoundCloud","40":"reactPlayerStreamable","41":"reactPlayerTwitch","42":"reactPlayerVidyard","43":"reactPlayerVimeo","44":"reactPlayerWistia","45":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"e88628e81f2174929273","1":"f13318ac8301440e750c","2":"f3e9059f8c2a75df70f2","3":"9db0f96308aa2b4b34b0","4":"de3629c7c272c649b815","5":"9a0acb5dcfc78dd8fdc9","6":"615e2644e7e95143546e","7":"25d3944820546ccdd068","8":"ed47b18ec0f39d633ab1","9":"71a055a9f9d798bc6901","10":"b5bd0627620e295fa744","11":"2cc8543b777d75b0d6b2","12":"f97830c868a8c63854c2","13":"9e31d69fc0d6243703ef","14":"9b0d4c8c46aa97191419","17":"c95a411f3826a1c7baac","18":"c3580ac0a387b7966c3a","19":"3b306abd077cbd29e38e","20":"e7b59266d621ef2311ce","21":"244f33333fe49f1585ab","22":"9534344203fdb5070d16","23":"bc060d91baab74fe6ab3","24":"1d2ff548c9101949ae3e","25":"02c9643e009625e4c173","26":"f3f1192ec5b78f431ff3","27":"06751642f75f62480a71","28":"0b82b4153c083a9b341b","29":"801557a2b43f3b546c4b","30":"098b06c40aa0b98ef492","31":"900bdd1e78b63ee9796b","33":"79fbadd2e0404a8f8dea","34":"774598e35fe9c88abdc8","35":"a5601cfe781866c45478","36":"87a4e5b37886e62c5e12","37":"119c7b0bae4a602f1a76","38":"274088b5a01aeb596ae9","39":"cb069231dc760aad5723","40":"bab88e8a06106a415af7","41":"65233e20c7bfdfa7416b","42":"8d7a0c990e394f99c768","43":"c3f84ee6ddc10fdce596","44":"4709540a7a474be582d9","45":"d19fb16360db81dbf84f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"425165828cbca8c3464f0263eb269c76bc54a018","1":"framework","2":"styles","3":"94cf43ee5387c53f6634a485d1b467e7cce5efbe","4":"14a55478639e0cdf3cd4295950bf8d289493dc1d","5":"fb62585424584bf0aebd50b6c31649333436e699","6":"2fbf9dd2","7":"8b80437e12f5ecd78ade0da750decdae4c4ad33a","8":"16811c1f5bbd073a562b37b9515672090c81201a","9":"fd2cc789a711de3bc39f0d7b21319bf255ccaa06","10":"213ea3da8bbff2fd5791aba3ac8b2bdf5e2890c2","11":"94726e6d","12":"94ff9f3230cde4617b6e678422f49ec13db4bed2","13":"cdf3896354c49e2801630ab4cf184284fdbe0d65","14":"component---src-pages-oftwomindsmx-js","17":"component---cache-caches-gatsby-plugin-offline-app-shell-js","18":"component---src-pages-404-js","19":"component---src-pages-about-js","20":"component---src-pages-contact-careers-js","21":"component---src-pages-contact-client-inquiries-js","22":"component---src-pages-contact-index-js","23":"component---src-pages-contact-mentorship-program-js","24":"component---src-pages-index-js","25":"component---src-pages-philosophy-js","26":"component---src-pages-preview-js","27":"component---src-pages-privacy-policy-js","28":"component---src-pages-roanne-js","29":"component---src-pages-work-js","30":"component---src-templates-category-js","31":"component---src-templates-project-js","33":"reactPlayerDailyMotion","34":"reactPlayerFacebook","35":"reactPlayerFilePlayer","36":"reactPlayerKaltura","37":"reactPlayerMixcloud","38":"reactPlayerPreview","39":"reactPlayerSoundCloud","40":"reactPlayerStreamable","41":"reactPlayerTwitch","42":"reactPlayerVidyard","43":"reactPlayerVimeo","44":"reactPlayerWistia","45":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"4456bc033bbaa456bf19","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
